import { SendToast } from "@networkraildigitalfactory/components";
import { useHistory } from "react-router";
import { useNotifications } from "../useAPI";

const useNotificationActions = (fetchLatest) => {
  const [, markAsRead] = useNotifications(
    {
      method: "PUT",
    },
    {
      manual: true,
    }
  );

  const history = useHistory();

  const markAndFetch = async (apiUrl) => {
    await markAsRead({ url: apiUrl });
    await fetchLatest();
  };

  const viewNotification = async (e, notification) => {
    try {
      const { _id, isRead, url } = notification;
      if (e.key && e.key !== "Enter") {
        return undefined;
      }
      if (!isRead) {
        await markAndFetch(`markAsRead/${_id}`);
      }

      history.push(url);
    } catch (error) {
      console.error(error);
      SendToast("There was an error marking your notification as read", "error");
    }
    return false;
  };

  const markAllNotificationsAsRead = async (hasUnreadNotifications) => {
    try {
      if (!hasUnreadNotifications) {
        return SendToast("You currently have no unread notifications", "error");
      }
      await markAndFetch("markAllAsRead");
      SendToast("All notifications have successfully been marked as read", "success");
    } catch (e) {
      console.error(e);
      SendToast("There was an error marking your notification as read", "error");
    }
    return false;
  };

  return { viewNotification, markAllNotificationsAsRead };
};

export default useNotificationActions;
